import { MatTableDataSource } from '@angular/material/table';
import { CategoriesItem } from '../categories/categories.model';


export class RootCategoriesDataSource extends MatTableDataSource<CategoriesItem> {
  
  
  constructor(public dataCategories?: CategoriesItem[]) {
    super(dataCategories)
  }

  disconnect(): void {//this is a method
  }

}

